import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import 'antd/dist/antd.css';
import { Form, Input, Button, Row, Col, Breadcrumb } from 'antd';
import { isNumber, Translate, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEcole, updateEcole, createEcole, reset } from './ecole.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const EcoleUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const ecoleEntity = useAppSelector(state => state.ecole.entity);
  const loading = useAppSelector(state => state.ecole.loading);
  const updating = useAppSelector(state => state.ecole.updating);
  const updateSuccess = useAppSelector(state => state.ecole.updateSuccess);

  const handleClose = () => {
    props.history.push('/ecole');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEcole(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEcole = values => {
    const entity = {
      ...ecoleEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEcole(entity));
    } else {
      dispatch(updateEcole(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...ecoleEntity,
        };

  const validateMessages = {
    required: '${label} est obligatoire',
    types: {
      email: '${label} est invalide',
    },
  };

  return (
    <div>
      {isNew ? (
        <Breadcrumb className="p-4">
          <Breadcrumb.Item>
            <a href="/">{ecoleEntity.nom}</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a href="/ecole">Ecoles</a>
          </Breadcrumb.Item>
        </Breadcrumb>
      ) : (
        <Breadcrumb className="p-4">
          <Breadcrumb.Item>
            <a href="/">{ecoleEntity.nom}</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a href="/ecole">Ecoles</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a href={`ecole/${ecoleEntity.id}`}>Details</a>
          </Breadcrumb.Item>
        </Breadcrumb>
      )}

      <Row className="justify-content-center">
        <Col span="16">
          {isNew ? (
            <h2 id="korischoolApp.ecole.home.createOrEditLabel" data-cy="EcoleCreateUpdateHeading">
              <Translate contentKey="korischoolApp.ecole.home.createLabel">Create a Ecole</Translate>
            </h2>
          ) : (
            <h2 id="korischoolApp.ecole.home.createOrEditLabel" data-cy="EcoleCreateUpdateHeading">
              <Translate contentKey="korischoolApp.ecole.home.editLabel">Edit a Ecole</Translate>
            </h2>
          )}
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col span="16">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <Form
              labelCol={{ span: '8' }}
              layout="vertical"
              validateMessages={validateMessages}
              onFinish={saveEcole}
              initialValues={!isNew && ecoleEntity}
            >
              <Form.Item name="nom" label="Etablissement" id="ecole-nom" data-cy="nom" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item name="adresse" label="Adresse" id="ecole-nom" data-cy="adresse" rules={[{ required: true }]}>
                <Input.TextArea />
              </Form.Item>
              <Form.Item name="telephone" label="Telephone" id="ecole-nom" data-cy="telephone" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item name="email" label="Email" id="ecole-mail" data-cy="mail" rules={[{ required: true }, { type: 'email' }]}>
                <Input />
              </Form.Item>
              <Form.Item>
                <Button
                  id="cancel-save"
                  data-cy="entityCreateCancelButton"
                  href="/ecole"
                  size="middle"
                  style={{ backgroundColor: 'black', color: '#F28E19' }}
                >
                  <FontAwesomeIcon icon="arrow-left" />
                  &nbsp;
                  <span className="d-none d-md-inline">
                    <Translate contentKey="entity.action.back">Back</Translate>
                  </span>
                </Button>
                &nbsp;
                <Button
                  style={{ backgroundColor: '#F28E19', color: 'white' }}
                  id="save-entity"
                  data-cy="entityCreateSaveButton"
                  htmlType="submit"
                  disabled={updating}
                >
                  <FontAwesomeIcon icon="save" />
                  &nbsp;
                  <Translate contentKey="entity.action.save">Save</Translate>
                </Button>
              </Form.Item>
            </Form>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EcoleUpdate;
